var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"now-play"},[_c('span',{staticClass:"np-action"},[_vm._v(_vm._s(_vm.event))]),_vm._v(" "),_c('span',{staticClass:"np-title"},[_vm._v(_vm._s(_vm.currentAudio.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f47252c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayerStatus.vue
// module id = null
// module chunks = 